module.exports = __webpack_public_path__ + "static/media/22_Natascha_L_webfinal.03b45b1c.jpg";